import React from 'react'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'

export default () => {
    return(
        <LoaderWrapper>
            <Loader type="Circles" color="#99E1CD" height={80} width={80}/>
        </LoaderWrapper>
    )
}

const LoaderWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
`



// WEBPACK FOOTER //
// ./src/components/common/Loader.js